import { render, staticRenderFns } from "./VpnKey.vue?vue&type=template&id=377c4179&"
import script from "./VpnKey.vue?vue&type=script&lang=js&"
export * from "./VpnKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports